import { Bar } from 'react-chartjs-2';
import { Chart, ChartData, ChartOptions, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement} from "chart.js";
import { StatsChartData } from 'models/StatisticChart';

Chart.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const BarChart = ({labels, datasets}:StatsChartData) => {
    const chartData: ChartData<'bar'> = {
        labels,
        datasets
    }

    const chartOptions: ChartOptions<'bar'> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'left',
                display: false
            }
        }
    }

    return (
        <div style={{width: '100%', height: '200px'}}>
            <Bar data={chartData} options={chartOptions} />
        </div>
    )
}

export default BarChart;